import icon  from '@material-ui/icons/Input';
import list from './BoxList';
import show from './BoxView';
//import downloads from './Downloads'
//import edit from './SamplesEdit';



export default{ 
    list,
    show, 
   // edit,
    icon
};